document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".salt-slider-container");
  const slides = document.querySelectorAll(".salt-slide");
  const prevBtn = document.querySelector(".prev-btn");
  const nextBtn = document.querySelector(".next-btn");

  let index = 0;
  const totalSlides = slides.length;
  const slideWidth = slides[0].clientWidth + 20; // Padding dahil

  nextBtn.addEventListener("click", () => {
    if (index < totalSlides - 1) {
      index++;
      slider.style.transform = `translateX(-${index * slideWidth}px)`;
    }
  });

  prevBtn.addEventListener("click", () => {
    if (index > 0) {
      index--;
      slider.style.transform = `translateX(-${index * slideWidth}px)`;
    }
  });
});
